import { DateTime } from 'luxon';

import type { DateTimeRange } from '#components/shared/datePeriod.ts';
import { isServiceOrder, type OrderSummary } from '#domain/Order.ts';

export const matchesOrderTimeRange = (order: OrderSummary, range?: DateTimeRange) => {
    if (!range) {
        return true;
    }
    const stop = isServiceOrder(order) ? order.executionStop : order.loadingStop;
    const start = DateTime.fromISO(stop.startTarget).toMillis();
    const end = DateTime.fromISO(stop.endTarget).toMillis();
    return Number.isFinite(start) && Number.isFinite(end) && end >= start && start < range.end && end >= range.start;
};
